import { render } from "./GoogleReviewPrompt.vue?vue&type=template&id=f1286bbe&scoped=true"
import script from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"
export * from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"

import "./GoogleReviewPrompt.vue?vue&type=style&index=0&id=f1286bbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1286bbe"]])

export default __exports__